import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AcceptCookies.module.scss";
import Alert from "components/Alert/Alert";
import LanguageSwitcher from "components/LanguageSwitcher/LanguageSwitcher";

const AcceptCookies = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [shouldPulse, setShouldPulse] = useState(false);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        const consentGiven = localStorage.getItem("acceptCookies");
        if (!consentGiven) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("acceptCookies", "true");
        setIsVisible(false);
    };

    const handleClickOutside = () => {
        if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
            setShouldPulse(true);
            setTimeout(() => setShouldPulse(false), 1000);
        }
    };

    if (!isVisible) return null;

    return (
        <div className={styles.modalOverlay} onClick={() => handleClickOutside()}>
            <LanguageSwitcher></LanguageSwitcher>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h2>{t("gdpr.title")}</h2>
                </div>
                <div className={styles.modalBody}>
                    <p dangerouslySetInnerHTML={{ __html: t("gdpr.content") + " " + t("gdpr.content2") }}></p>
                </div>
                <button
                    ref={buttonRef}
                    className={`${styles.modalButton} ${shouldPulse ? styles.pulse : ""}`}
                    onClick={handleAccept}
                >
                    {t("gdpr.acceptButton")}
                </button>
            </div>
        </div>
    );
};

export default AcceptCookies;
